import * as THREE from 'three'
import React, { useMemo } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy} from '../../../../../../../../utils/Functions';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';
import { getSimilarTexture, textureAppliedFor } from '../../../../../../../../redux/reducers/utils';
const WallModel = () => {
    const { gl } = useThree ();

    const wallThickness = 0.005;
    const cbFrontBackWallOffset = 0.16;
    const offsetWithDoorThickness = 0.127;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement !== undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false
    const isEqualHeight = (params.lean_p_h + ((params.b_l_t_r_p / 12) * (params.lean_p_w)) == params.p_h) ? 0.2 : 0;
    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])
    
    // const textureObj = useMemo(() => {
    //     let similarSidingTextures = getSimilarTexture(params.wallTexture)
    //     let similarWainscotTextures = getSimilarTexture(params.wainscotTexture)

    //     const texture = const_var.wallTextureObj?.[similarSidingTextures]?.clone();
    //     const wainscotTexture = const_var.wallTextureObj?.[similarWainscotTextures]?.clone();

    //     const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
    //     const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        
    //     if(metalTexture){
    //         if (params.wallOrientation == "vertical") metalTexture.rotation = Math.PI/-2;
    //         else metalTexture.rotation = 0;
    //     }
    //     if(lightTexture) lightTexture.rotation = metalTexture.rotation;
    //     if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
    //     if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

    //     return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    // }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    // const dutchDelModelBack = useMemo(() => {
    //     const freeSpace = 1;
    //     let cornerFreeSpaceW = (params.leanR_p_w - freeSpace) / 6;
    //     const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanR_p_h:  params.leanR_p_h
    //     let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
    //     if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

    //     if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
    //     if (params.add_right_lean && (params.p_b_c_b_r_b === "Half Dutch End" || params.p_b_c_b_r_b === "Half End")) {
    //         const model = new THREE.Shape();
    //         model.moveTo(-(params.leanR_p_w / 2 - freeSpace), 0);

    //         if (params.p_b_c_b_r_b === "Half Dutch End") {
    //             model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
    //             model.lineTo(-(params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
    //             model.lineTo((params.leanR_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
    //             model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
    //         } else {
    //             model.lineTo(-(params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
    //             model.lineTo((params.leanR_p_w / 2 - freeSpace), leftHeight - freeSpace);
    //         }
    //         model.lineTo((params.leanR_p_w / 2 - freeSpace), 0);

    //         return model;
    //     } else {
    //         return []
    //     }
    // }, [params.add_right_lean, params.leanR_p_w, params.leanR_p_h, params.p_b_c_b_r_b])
    
    // Back Wall - CSG
    const backWallModelObj = useMemo(() => {
        // if(params.p_b_c_b_r_b == 'Open' && !params.add_storage_check_right) return;
        let outerModel;
        let innerModel;
        let wainscotModel;

        //************************* */ inner wall geometry
        const backWallModel = new THREE.Shape();
        if (params.p_r_s === 1) {
            backWallModel.moveTo(-(params.leanR_p_w - wallThickness), 0);
            backWallModel.lineTo(-(params.leanR_p_w - wallThickness), params.leanR_p_h);
            backWallModel.lineTo(-(params.leanR_p_w - wallThickness), params.leanR_p_h + const_var.roofRegularDst);
            backWallModel.quadraticCurveTo(-(params.leanR_p_w - wallThickness), params.leanR_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pR / 12) / 10, 
                                            -(params.leanR_p_w - wallThickness - const_var.roofRegularDst + 0.1), params.leanR_p_h + const_var.roofRegularDst * (2 + params.b_l_t_r_pR / 12))
            backWallModel.lineTo(0, params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w - wallThickness) + const_var.roofRegularDst * (2)));
            backWallModel.lineTo(0, 0);
            backWallModel.closePath();
        } else {
            backWallModel.moveTo(-params.leanR_p_w + offsetWithDoorThickness - 0.12, params.leanR_p_h);
            backWallModel.lineTo(0, params.leanR_p_h + params.leanR_p_w / 12 * params.b_l_t_r_pR - isEqualHeight);
            backWallModel.lineTo(0, 0);
            backWallModel.lineTo(-params.leanR_p_w + offsetWithDoorThickness - 0.12, 0);
            backWallModel.closePath();
        }

        const meshBackWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallModel, extrudeSettings(0.005)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshBackDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanStorageBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        // const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModelBack, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshBackWallModel_Temp = meshBackWallModel.clone();
        meshBackWallModel_Temp.rotateY(Math.PI)
        meshBackWallModel_Temp.position.set(params.p_w / 2, 0, -params.leanR_p_d / 2 - cbFrontBackWallOffset + wallThickness);
        meshBackWallModel_Temp.updateMatrixWorld();
    
        let meshBackDelModel_Temp = meshBackDelModel.clone();
        meshBackDelModel_Temp.position.set(0, 0, -params.leanR_p_d / 2 - 0.5);
        meshBackDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w - 0.2, 0, -params.leanR_p_pos - params.rightLeanStoragePosition);
        meshSideDelModel_Temp.rotateY(Math.PI / 2);
        meshSideDelModel_Temp.updateMatrixWorld();

        // let meshDutchDelModel_Temp = meshDutchDelModel.clone();
        // meshDutchDelModel_Temp.position.set((params.p_w / 2 + params.leanR_p_w / 2),0, - params.leanR_p_d / 2 - 0.5);
        // meshDutchDelModel_Temp.updateMatrixWorld();
    
        const meshBackWallModel_CSG = CSG.fromMesh(meshBackWallModel_Temp);
        const meshBackDelModel_CSG = CSG.fromMesh(meshBackDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        // const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);
    
        const backWallModel_CSG = meshBackWallModel_CSG.subtract(meshBackDelModel_CSG);
        const meshSideInnerDelModel_CSG =  backWallModel_CSG.subtract(meshSideDelModel_CSG);
        // const meshBackInnerModel_CSG = meshSideInnerDelModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGBackWallModel = CSG.toMesh(meshSideInnerDelModel_CSG, new THREE.Matrix4())
    
        innerModel = CSGBackWallModel.geometry;

        //************************* */ outer wall geometry
        let verticalHorizontalPosB = {"x": params.p_w / 2 + params.leanR_p_w ,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : params.leanR_p_d / -2 - 0.19}
        let verticalHorizontalRotB = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}
        let patternLengthB = params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w)) + (params.p_w_c_n ? -2.935 : 0) + (params.p_r_s === 1 ? 3 : 0)
        let patternDepthB = params.leanR_p_w

        // let wallpanelValue = (params.p_r_s === 1) ?  0.1 : 0
        // const backWallCutModel = new THREE.Shape();
        // backWallCutModel.moveTo((params.p_w / 2), params.leanR_p_h + ((params.b_l_t_r_pR / 12) * (params.leanR_p_w))); //right lean left top
        // backWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), params.leanR_p_h); //right lean right top
        // backWallCutModel.lineTo((params.p_w / 2 + params.leanR_p_w), wallpanelValue); //right lean right bottom
        // backWallCutModel.lineTo((params.p_w / 2), wallpanelValue); //right lean left bottom
    
        const meshWallModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthB, isPattern), extrudeSettings(patternDepthB)))  
        const meshGableDelModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        // const meshGableDelModelB = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallCutModel, extrudeSettings(1)))
    
        // let meshGableDelModel_TempB = meshGableDelModelB.clone();
        // meshGableDelModel_TempB.position.set(0,0,params.leanR_p_d / - 2 - 0.5);
        // meshGableDelModel_TempB.updateMatrixWorld();

        let meshGableDelModel_TempB = meshGableDelModelB.clone();
        meshGableDelModel_TempB.position.set(params.p_w / 2, 0, -params.leanR_p_d / 2 + 0.5 )
        meshGableDelModel_TempB.rotation.set(0, Math.PI, 0);
        meshGableDelModel_TempB.updateMatrixWorld();
    
        let meshWallModel_TempB = meshWallModelB.clone();
        meshWallModel_TempB.position.set(verticalHorizontalPosB.x,verticalHorizontalPosB.y,verticalHorizontalPosB.z);
        meshWallModel_TempB.rotation.set(verticalHorizontalRotB.x,verticalHorizontalRotB.y,verticalHorizontalRotB.z);
        meshWallModel_TempB.updateMatrixWorld();

        let meshSideOuterDelModel_Temp = meshSideDelModel.clone();
        meshSideOuterDelModel_Temp.position.set(params.p_w / 2 + params.leanR_p_w - 0.2, 0, -params.leanR_p_pos - params.rightLeanStoragePosition);
        meshSideOuterDelModel_Temp.rotateY(Math.PI / 2);
        meshSideOuterDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSGB = CSG.fromMesh(meshWallModel_TempB);
        const meshGableDelModel_CSGB = CSG.fromMesh(meshGableDelModel_TempB);
        const meshSideOuterDelModel_CSG = CSG.fromMesh(meshSideOuterDelModel_Temp);
    
        const wallModel_CSGB = meshWallModel_CSGB.subtract(meshBackDelModel_CSG);
        const GableModel_CSGB = wallModel_CSGB.intersect(meshGableDelModel_CSGB);
        const SideOuterDelModel_CSG = GableModel_CSGB.subtract(meshSideOuterDelModel_CSG);
        // const MeshFrontOuterModel_CSG = SideOuterDelModel_CSG.subtract(meshDutchDelModel_CSG);
    
        const CSGWallModelB = CSG.toMesh(SideOuterDelModel_CSG,new THREE.Matrix4())

        outerModel = CSGWallModelB.geometry;

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosB = {"x": params.p_w / 2 + params.leanR_p_w ,"y" : 0, "z" : params.leanR_p_d / -2 - 0.16 - 0.03}
        let wainscotVerticalHorizontalRotB = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}
        let lengthPatternB = 3
        let depthPatternB = patternDepthB

        const meshBackWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternB, isPattern), extrudeSettings(depthPatternB)))
        let meshBackWainscotModel_Temp = meshBackWainscotModel.clone();
        meshBackWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosB.x,wainscotVerticalHorizontalPosB.y,wainscotVerticalHorizontalPosB.z);
        meshBackWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotB.x,wainscotVerticalHorizontalRotB.y,wainscotVerticalHorizontalRotB.z);
        meshBackWainscotModel_Temp.updateMatrixWorld();

        const meshBackWainscotModel_CSG = CSG.fromMesh(meshBackWainscotModel_Temp);

        const backWainscotModel_CSG = meshBackWainscotModel_CSG.subtract(meshBackDelModel_CSG);
        const sideDelWainscotModel_CSG = backWainscotModel_CSG.subtract(meshSideOuterDelModel_CSG);
        // const finalFrontwainscotModel_CSG = sideDelWainscotModel_CSG.subtract(meshDutchDelModel_CSG);

        const CSGBackWainscotModel = CSG.toMesh(sideDelWainscotModel_CSG, new THREE.Matrix4())

        wainscotModel = CSGBackWainscotModel.geometry;
 
        return {outerModel, innerModel, wainscotModel}
    
    }, [params.wallTexture,params.p_v_w, params.p_h, params.p_w, params.leanR_p_pos, params.rightLeanStoragePosition, params.p_r_p, params.p_b_c_b_r_b, params.p_r_s, params.leanR_p_w, params.b_l_t_r_pR, params.leanR_p_d, params.leanR_p_h, const_var.newDoorsArray, params.p_w_c_n, params.p_b_c_b_r_b, isPattern]);
    
    return (
        <>
            <group name='out-side-wall'>
                {backWallModelObj?.outerModel &&
                    <mesh name="R_L_B_S_W" geometry={backWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                    </mesh>
                }
            </group>
                
            <group name='in-side-wall'>
                {backWallModelObj && backWallModelObj?.innerModel &&
                    <mesh name="back" geometry={backWallModelObj?.innerModel} position={[0, 0, wallThickness * 2 + 0.01]}>
                        <MaterialInnerWall texture={texture} visibleSection={"rightLean"} />
                    </mesh>
                }
            </group>

            {/* Back Wainscot  */}
            {params.p_w_c_n == true && backWallModelObj?.wainscotModel &&
                <mesh name="R_L_B_S_W_wainscot" geometry={backWallModelObj?.wainscotModel} position={[0,0,-0.005]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"rightlean"} />
                </mesh>
            }
        </>
    )
}

export default WallModel